/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_KickerInputs */



/**
* | output |
* | --- |
* | "What you get" |
*
* @param {Onboarding_Value_KickerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_kicker = /** @type {((inputs?: Onboarding_Value_KickerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_KickerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wat je krijgt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce que vous recevez")
	return /** @type {LocalizedString} */ ("What you get")
});